import { Link } from "react-router-dom";

export function LogoMark({ className = "h-10 w-10" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <rect x="2" y="2" width="44" height="44" rx="8" fill="#1A237E" />
      <path
        d="M14 20h20v4a10 10 0 0 1-20 0v-4z"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path d="M18 20v-3M24 20v-4M30 20v-3" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" />
      <rect x="13" y="36" width="22" height="2.5" rx="1.25" fill="#FFFFFF" />
    </svg>
  );
}

export const LOGO_URL = "https://customer-assets-eiarnc6j.emergentagent.net/wingman/1b579b6a-2d4e-44eb-97e9-b3d7a8a3bfc9/attachments/0fd8391de276473bb2d6841fc2d34192_IMG_3007.jpg";

export default function Logo({ dark = false, linked = true }) {
  const content = (
    <span className="flex items-center" data-testid="site-logo">
      <img
        src={LOGO_URL}
        alt="Mobile Kitchen Company — Temporary Kitchen Hire Specialists"
        className={`h-16 sm:h-20 w-auto rounded ${dark ? "bg-white p-1.5" : ""}`}
      />
    </span>
  );
  return linked ? <Link to="/">{content}</Link> : content;
}
